import { render } from "./SongEditView.vue?vue&type=template&id=11a8d39d"
import script from "./SongEditView.vue?vue&type=script&lang=js"
export * from "./SongEditView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__